import { render, staticRenderFns } from "./OffsetModal.vue?vue&type=template&id=1983ce34&scoped=true"
import script from "./OffsetModal.vue?vue&type=script&lang=js"
export * from "./OffsetModal.vue?vue&type=script&lang=js"
import style0 from "./OffsetModal.vue?vue&type=style&index=0&id=1983ce34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983ce34",
  null
  
)

export default component.exports